import styled from "styled-components";

const Data = styled.div`
    padding: 0 15px;
`;
export default Data;
